import { render, staticRenderFns } from "./AlteracaoSenhaOffice.vue?vue&type=template&id=57bef4f8&scoped=true"
import script from "./AlteracaoSenhaOffice.vue?vue&type=script&lang=js"
export * from "./AlteracaoSenhaOffice.vue?vue&type=script&lang=js"
import style0 from "./AlteracaoSenhaOffice.vue?vue&type=style&index=0&id=57bef4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bef4f8",
  null
  
)

export default component.exports